import React, { useRef } from "react";
import ReactSelect from "react-select";

export const MultiSelect = ({
  options,
  value,
  onChange,
  placeholder,
  onKeyDown,
  isClearable,
  width = "100%",
  allLabel = "All",
}) => {
  const customStyles = {
    container: (base) => ({
      ...base,
      width,
    }),
    control: (base, state) => ({
      ...base,
      width: "100%",
      borderColor: "var(--cards-border-color)",
      boxShadow: "none",
      borderRadius: "6px",
      "&:hover": {
        borderColor: "var(--cards-border-color)",
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: "#bfbfbf",
      fontSize: "14px",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "var(--selected-bg-color)",
      border: "1px solid none",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "var(--primary-text-color)",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "var(--main-theme-color)",
      ":hover": {
        backgroundColor: "none",
        color: "none",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "var(--selected-bg-color)"
        : state.isFocused
        ? "#f5f5f5"
        : "none",
      color: "rgba(0, 0, 0, 0.85)",
      fontSize: "14px",
      ":active": {
        backgroundColor: "none",
      },
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  // isOptionSelected sees previous value after onChange
  const valueRef = useRef(value);
  valueRef.current = value;

  const selectAllOption = {
    value: "<SELECT_ALL>",
    label: allLabel,
  };

  const isSelectAllSelected = () => valueRef.current.length === options.length;

  const isOptionSelected = (option) =>
    valueRef.current.some(({ value }) => value === option.value) ||
    isSelectAllSelected();

  const getOptions = () => [selectAllOption, ...options];

  const getValue = () => (isSelectAllSelected() ? [selectAllOption] : value);

  const handleChange = (newValue, actionMeta) => {
    const { action, option, removedValue } = actionMeta;

    if (action === "select-option" && option.value === selectAllOption.value) {
      onChange(options, actionMeta);
    } else if (
      (action === "deselect-option" &&
        option.value === selectAllOption.value) ||
      (action === "remove-value" &&
        removedValue.value === selectAllOption.value)
    ) {
      onChange([], actionMeta);
    } else if (
      actionMeta.action === "deselect-option" &&
      isSelectAllSelected()
    ) {
      onChange(
        options.filter(({ value }) => value !== option.value),
        actionMeta
      );
    } else {
      onChange(newValue || [], actionMeta);
    }
  };

  return (
    <ReactSelect
      isOptionSelected={isOptionSelected}
      options={getOptions()}
      value={getValue()}
      onChange={handleChange}
      hideSelectedOptions={false}
      closeMenuOnSelect={false}
      isMulti
      placeholder={placeholder}
      styles={customStyles}
      onKeyDown={onKeyDown}
      isClearable={isClearable}
      menuPortalTarget={document.body}
      menuPosition="fixed"
    />
  );
};
